// Function to perform custom sorting of lots based on defined parameters
// Function to perform custom sorting of lots based on defined parameters
import {BLUV2_columns} from "@/modules/constants";

function customLotSequencing(lotsArray, sortingParameters, keyMap = {}) {
  // Helper function to check if the key represents a dynamic field
  function isDynamicField(key) {
    return key.startsWith('dynamic_field.');
  }

  // Helper function to extract dynamic field value
  function getDynamicFieldValue(lot, key) {
    const parts = key.split('.');
    if (parts.length === 2 && lot.dynamic_fields && lot.dynamic_fields.en) {
      return lot.dynamic_fields.en[parts[1]] ? lot.dynamic_fields.en[parts[1]] : null;
    }
    return null;
  }

  // Helper function to get the field value based on key
  function getFieldValue(lot, key) {
    if (isDynamicField(key)) {
      return getDynamicFieldValue(lot, key);
    }
    return lot[key] ? lot[key] : null;
  }

  // Helper function to parse date strings and return a comparable format
  function parseDateString(dateString) {
    return new Date(dateString).getTime(); // Convert date string to timestamp for comparison
  }

  // Helper function to apply type conversion based on keyMap
  function convertValue(value, type) {
    if (value === null) return null;

    switch (type) {
      case 'boolean':
        return Boolean(value);
      case 'number':
        return Number(value);
      case 'date':
        return parseDateString(value);
      case 'string':
      default:
        return value.toString();
    }
  }

  // Helper function to handle different data types during comparison
  function compareValues(a, b, type) {
    // Handle null values
    if (a === null && b === null) return 0;
    if (a === null) return type === 'asc' ? 1 : -1;
    if (b === null) return type === 'asc' ? -1 : 1;

    // Compare as specified in the keyMap
    if (typeof a === typeof b) {
      return type === 'asc' ? (a > b) - (a < b) : (b > a) - (b < a);
    }

    // Fallback for mismatched types
    return type === 'asc' ? a.toString().localeCompare(b.toString()) : b.toString().localeCompare(a.toString());
  }

  // Helper function to sort based on top_data and sorting order
  function sortWithTopData(lots, key, topData, type) {
    return lots.sort((a, b) => {
      const aValue = convertValue(getFieldValue(a, key), keyMap[key] || typeof getFieldValue(a, key));
      const bValue = convertValue(getFieldValue(b, key), keyMap[key] || typeof getFieldValue(b, key));

      // Check if either value is in the topData array
      const aTopIndex = topData.indexOf(aValue);
      const bTopIndex = topData.indexOf(bValue);

      // Prioritize items in topData first
      if (aTopIndex !== -1 && bTopIndex === -1) return -1;
      if (aTopIndex === -1 && bTopIndex !== -1) return 1;
      if (aTopIndex !== -1 && bTopIndex !== -1) return aTopIndex - bTopIndex;

      // If neither are in topData, perform regular comparison using compareValues
      return compareValues(aValue, bValue, type);
    });
  }

  // Reverse the sorting parameters to apply the last sorting parameter first
  sortingParameters.sort((a, b) => b.position - a.position);

  // Apply sorting tiers one by one, starting from the last position to maintain stability
  for (const param of sortingParameters) {
    const { key, type, top_data = [] } = param;

    // Sort the entire lots array based on the current tier's key
    lotsArray = sortWithTopData(lotsArray, key, top_data, type);
  }

  return lotsArray;
}

const BatchLotUpV2Service = {
  sortItems: customLotSequencing,
  setColumns(itemsArr) {
    localStorage.setItem(BLUV2_columns, JSON.stringify(itemsArr))
  },
  getColumns() {
    let tmpItems = localStorage.getItem(BLUV2_columns)
    return tmpItems ? JSON.parse(tmpItems) : []
  }
};

export default BatchLotUpV2Service;
